import { render, staticRenderFns } from "./process-type.vue?vue&type=template&id=159592f1&"
import script from "./process-type.vue?vue&type=script&lang=js&"
export * from "./process-type.vue?vue&type=script&lang=js&"
import style0 from "./process-type.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports